export function upgrade(userSettings) {
  const {notifications} = userSettings

  if (!notifications) {
    userSettings.notifications = {revisionMode: {}}
  }
}

export const DEFAULT_SETTINGS = {
  trialActivatedMessageSeen: false,
  isLiked: false,
  isQuickMenuShown: false,
  tips: {
    version: 0
  },
  favorites: {
    fonts: [],
    colors: []
  },
  preferences: {
    autoConfirmSwapVideo: false
  },
  newFeatures: {
    'character-builder': {
      dismissedTimestamp: undefined,
      viewState: 'new'
    }
  },
  notifications: {
    revisionMode: {}
  }
}
  